export default "__VITE_ASSET__DYsiNPtN__"